<template>
    <div class="ur-lnb" :class="urLnbClass">
        <!-- [COLLAPSE] Items -->
        <div class="ur-lnb__collapse-label" @click="toggleSide" v-if="collapse">
            <ur-icon>slide_left</ur-icon>
        </div>
        <div class="ur-lnb__collapse-hide">Menu</div>

        <!-- [SEARCH] -->
        <div class="ur-lnb__search-wrapper" v-if="search" >
            <div class="ur-lnb__search">
                <div class="ur-lnb__search-tip">Search index</div>
                <ur-text-field class="ur-lnb__search-text-field" placeholder="Search" v-model="searchKeyword" searchable/>
            </div>
        </div>
        <!-- [SEARCH] End -->
        <!-- [TAB] -->
        <div class="ur-lnb__tab-wrapper" v-if="hasTab" :style="urLnbTablStyle">
            <div class="ur-lnb__toggle-wrapper">
                <ur-segment-wrapper primary v-model="currTabIdx">
                    <ur-segment-button value="0">Tab_1</ur-segment-button>
                    <ur-segment-button value="1">Tab_2</ur-segment-button>
                </ur-segment-wrapper>
            </div>
        </div>
        <!-- [TAB] End -->
        <!-- [MENUs] -->
        <div class="ur-lnb__menu-list-wrapper" :style="urLnbMenuStyle">
            <ur-lnb-menu-list :menu-list="menuList" :depth="1" :keyword="searchKeyword"/>
        </div>
        <!-- [MENUs] End -->
    </div>
</template>

<script>
    import urLnbMenuList from './urLnbMenuList';
    // ur-lnb 는 화면의 LNB 영역을 구성하는 컴포넌트입니다.
    // 화면 좌측에 표시되면서, 설정에 따라 title을 표시하거나 menu를 구성할 수 있습니다.
    // #ur-lnb is a component that composes the LNB area of ​​the screen.
    // #Displayed at the left of the screen, you can display the title or configure the menu depending on the settings.
    export default {
        name:'ur-lnb',
        components:{urLnbMenuList},
        props: {
            // $ver: v0.2.0
            // 컴포넌트의 메뉴 리스트입니다.
            // #This property specifies the menu list of the component.
            sideMenu: {
                type: Array,
                default: () => []
            },
            // $ver: v0.2.0
            // LNB에서 검색 입력창을 사용합니다.
            // #Use search box in LNB
            // $default: false
            search: {
                type: Boolean,
                default: false
            },
            // $ver: v0.2.0
            // LNB의 접기 기능을 사용합니다(좌측으로 접힙니다)
            // #Use collapse to LNB(move to left)
            // $default: false
            collapse: {
                type: Boolean,
                default: false
            }
        },
        provide() {return {side: this.sharedData}},
        data() {
            return {
                currUri: undefined,
                currTabIdx: '0',
                searchKeyword: '',
                toggleSideClose: false
            }
        },
        computed: {
            sharedData() {
                let rtn = {}, odf = Object.defineProperty;
                odf(rtn, "moveMenu"  , {get:()=>this.moveMenu});
                odf(rtn, "currUri"     , {get:()=>this.currUri});
                return rtn;
            },
            menuList() {
                let renderMenus = this.sideMenu[this.currTabIdx] || [];
                this.currUri = (renderMenus[0] && renderMenus[0].url)? renderMenus[0].url : ''; // initialize first selected menu
                for (let i = renderMenus.length - 1; i >= 0; i--) {
                    if (renderMenus[i].displayYn === 'N') {
                        renderMenus.splice(i, 1);
                    }
                }
                return renderMenus;
            },
            hasTab(){
                return (this.sideMenu.length === 2);
            },
            urLnbClass(){
                let clazz = [];
                if(this.toggleSideClose){
                    clazz.push('ur-lnb--collapse');
                }
                return clazz;
            },
            urLnbTablStyle(){
                let tabStyle = {};
                if(this.search){
                    tabStyle['margin-top'] = '68px';
                }
                return tabStyle;
            },
            urLnbMenuStyle(){
                let menuStyle = {};
                let marginTop = 0;
                // 아무것도 없을때
                if(!this.search && !this.hasTab){
                    return menuStyle;
                }
                if(this.search){
                    marginTop += 74;
                }
                if(this.hasTab){
                    marginTop += 88;

                }
                menuStyle['margin-top'] = marginTop + 'px';
                menuStyle['height'] = 'calc(100% - ' + (marginTop + 32) + 'px)';
                return menuStyle;
            }
        },
        methods:{
            moveMenu(url){
                this.currUri = url;
                this.$emit('move', url);
            },
            toggleSide(){
                this.toggleSideClose = !this.toggleSideClose;
            }
        }
    }
</script>
